import styled from 'styled-components/macro'

const SelectWrapper = styled.div`
  position: relative;
`

export default SelectWrapper
